module.exports = __webpack_public_path__ + "img/9788949192482.8c5ab9da.jpg";